import { getFeature } from 'Cloud/Application/FeaturesEs6';
import { IS_MOBILE_BROWSER } from 'reactApp/appHelpers/configHelpers';

type SubscriptionsInformerFeatureType = 'a' | 'b' | 'c' | undefined;

const INFORMER_PROMO_ID = 'subs-informer';
const INFORMER_EXPIRED_PROMO_ID = 'subs-expired-informer';

export const subsInformerStorageKey = `${INFORMER_PROMO_ID}`;

export const subsExpiredInformerStorageKey = `${INFORMER_EXPIRED_PROMO_ID}`;
export const subsExpiredInformerCountStorageKey = `${INFORMER_EXPIRED_PROMO_ID}-count`;

/** CLOUDWEB-19113: Инфоблок "Подписка закончится/закончилась" в облаке */
export const subscriptionInformerEnabled: SubscriptionsInformerFeatureType = !IS_MOBILE_BROWSER && getFeature('subs-informer');
// Интервал в днях
export const subscriptionInformerInterval: number = getFeature('subs-informer-interval') || 1;
export const subscriptionExpiredInformerEnabled: SubscriptionsInformerFeatureType =
    !IS_MOBILE_BROWSER && getFeature('subs-expired-informer');
